import { render, staticRenderFns } from "./PremiumBreakdown.vue?vue&type=template&id=0975c828&scoped=true&"
import script from "./PremiumBreakdown.vue?vue&type=script&lang=js&"
export * from "./PremiumBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PremiumBreakdown.vue?vue&type=style&index=0&id=0975c828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975c828",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDataTable,VDivider,VRow})
